import { styled } from "@mui/material";
import TruncateMarkup from "react-truncate-markup";
import { Truncate } from "@kaltura/mediaspace-shared-ui";
import { Tag } from "@kaltura/ds-react-components";

interface EntryTagsCellProps {
    tags: string[];
}

/**
 * Media table cell with entry tags
 */
export const EntryTagsCell = ({ tags }: EntryTagsCellProps) => {
    if (!tags.length) {
        return null;
    }

    return (
        <Truncate
            lines={1}
            showCount={true}
            showMoreWithCountWrapper={({ count }) => <StyledTag label={`+${count}`} />}
            role={"group"}
        >
            {tags.map((tag, index) => (
                <TruncateMarkup.Atom key={index}>
                    <StyledTag label={tag} isFirst={index === 0} />
                </TruncateMarkup.Atom>
            ))}
        </Truncate>
    );
};

// Truncate doesn't support flex containers, so do the spacing between the tags the old way
const StyledTag = styled(
    Tag,
    { shouldForwardProp: (propName) => propName !== "isFirst" }
)<{ isFirst?: boolean }>(({ theme, isFirst }) => ({
    marginLeft: theme.spacing(isFirst ? 0 : 1),
}));
